export var ScheduleTimezone;
(function (ScheduleTimezone) {
    ScheduleTimezone["SCHEDULE_TIMEZONE_UTC"] = "UTC";
    ScheduleTimezone["SCHEDULE_TIMEZONE_RESOURCE"] = "RESOURCE";
})(ScheduleTimezone || (ScheduleTimezone = {}));
